import { render, staticRenderFns } from "./Restricted.html?vue&type=template&id=214ea8ad&scoped=true&"
import script from "./Restricted.js?vue&type=script&lang=js&"
export * from "./Restricted.js?vue&type=script&lang=js&"
import style0 from "./Restricted.scss?vue&type=style&index=0&id=214ea8ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ea8ad",
  null
  
)

export default component.exports